import loadable from '@loadable/component';
import recurit from './recurit';

export default {
  '/:type/cooperate': loadable(() => import('./Cooperate')),
  '/rich-text': loadable(() => import('./RichText')),
  '/:type/rich-text': loadable(() => import('./RichText')),
  '/:type/bookerrata': loadable(() => import('./Bookerrata')),
  '/:type/goods-by-params': loadable(() => import('./GoodsByParams')),
  // 首页公开课查看全部
  '/:type/openclass/goods-by-params': loadable(() => import('./GoodsByParams')),
  '/:type/airecommend': loadable(() => import('./Airecommend')),
  '/:type/about': loadable(() => import('./About')),
  '/:type/paySuccess': loadable(() => import('./PaySuccess')), // 积分商城支付成功页面路由
  '/:type/my/paySuccess': loadable(() => import('./PaySuccess')), // 商城支付成功页面路由
  ...recurit,
  '/:type/branchCampus': loadable(() => import('./branchCampus')), // 全国分校
};
